<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'App',
  created() {

  },
  watch: {
    "$route"(to, from) {
      window.scrollTo(0, 0)
    },
  },
  methods: {
    ...mapMutations(['setuserInfoVal']),
  },
  mounted() {
    if (localStorage.getItem('userInfo') != null) {
      let userinfo = JSON.parse(localStorage.getItem('userInfo'))
      // console.log(userinfo)
      this.setuserInfoVal(userinfo)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.empty-margin {
  margin-top: 20px;
}

.qualityControl-box {
  min-height: calc(100vh - 220px);
  display: flex;
  flex-direction: column;
}
</style>
<style lang="less">
@color: #9C1D22;
.el-button{
  background-color: #8D1D22 !important;
  border-color: #8D1D22 !important;
  color: #fff !important;
}
.dialog-footer-info {
  .el-button--primary {
    background-color: #8D1D22;
    border-color: #8D1D22;
  }

  .el-button--primary:hover {
    background-color: #8D1D22;
    border-color: #8D1D22;
  }
}

html {
  background: #F5F5F7;
}
.el-pagination .el-select .el-input .el-input__inner{
  height: 32px;
}
.title-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;

  .nav-li {
    margin: 0 20px;
  }
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  margin-bottom: 26px;

  .title {
    color: #222222;
    font-size: 30px;
    line-height: 30px;
    font-weight: bold;
  }
}

.head-box {
  width: 100%;
  height: 166px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/images/b1.png") no-repeat;
  background-size: 100% 100%;
  color: #222222;
  font-size: 34px;
  font-weight: bold;
}

.paging {
  margin-top: 18px;
}

.center-box {
  width: 1300px;
  margin: 0 auto;
}

.crumbs {
  color: #737373;
  font-size: 14px;
  text-align: left;
  line-height: 18px;
  margin-top: 18px;
}

.title-nav {
  display: flex;
  align-items: center;

  .nav-li.active {
    color: @color;
    font-weight: bold;
  }

  .nav-li.active:before {
    content: '';
    display: block;
    position: absolute;
    background: @color;
    width: 20px;
    height: 2px;
    left: calc(50% - 10px);
    bottom: -5px;
  }

  .nav-li {
    position: relative;
    color: #737373;
    font-size: 18px;
    margin-left: 40px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue